module.exports = __webpack_public_path__ + "media/stylesheets/resident/images/fac-step2-7ad854880d41efd53483875a8d6c8c5c.svg";